import { CARD_STATUS } from '../../constants';
import { actionTypes } from './actions';

const simpleInitialState = {
  isLoading: false,
  hasError: false,
};

const initialData = {
  data: {
    files: [],
    cardStatus: CARD_STATUS.DRAFT,
    external: false,
  },
  ...simpleInitialState,
};

const ndfl3DataReducer = (state = initialData, action) => {
  switch (action.type) {
    case actionTypes.GET_DATA:
      return { ...initialData, ...{ isLoading: true } };

    case actionTypes.GET_DATA_SUCCESS:
      return { ...initialData, ...{ data: action.payload } };

    case actionTypes.GET_DATA_FAILURE:
      return { ...initialData, ...{ hasError: true, error: action.payload } };

    default:
      return state;
  }
};

const ndfl3CopyReducer = (state = simpleInitialState, action) => {
  switch (action.type) {
    case actionTypes.COPY:
      return { ...simpleInitialState, ...{ isLoading: true } };

    case actionTypes.COPY_SUCCESS:
      return { ...simpleInitialState, ...{ newCardId: action.payload } };

    case actionTypes.COPY_FAILURE:
      return { ...simpleInitialState, ...{ hasError: true, error: action.payload } };

    case actionTypes.RESET_COPY_DATA:
      return initialData;

    default:
      return state;
  }
};

const ndfl3ReSendReducer = (state = simpleInitialState, action) => {
  switch (action.type) {
    case actionTypes.RE_SEND:
      return { ...simpleInitialState, ...{ isLoading: true } };

    case actionTypes.RE_SEND_SUCCESS:
      return { ...simpleInitialState, ...{ newCardId: action.payload } };

    case actionTypes.RE_SEND_FAILURE:
      return { ...simpleInitialState, ...{ hasError: true, error: action.payload } };

    default:
      return state;
  }
};

export { ndfl3DataReducer, ndfl3CopyReducer, ndfl3ReSendReducer };
